import PropertySet from './property';

const trackingValues = new PropertySet();

export default trackingValues;
